module.exports = __webpack_public_path__ + "img/gift-imaes.635d0460.png";